import { render } from "./UserLearningProgressView.vue?vue&type=template&id=223c380e&scoped=true"
import script from "./UserLearningProgressView.vue?vue&type=script&lang=js"
export * from "./UserLearningProgressView.vue?vue&type=script&lang=js"

import "./UserLearningProgressView.vue?vue&type=style&index=0&id=223c380e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223c380e"]])

export default __exports__